import * as React from "react";
import { Button } from "@mui/material";
import { useRecordContext } from "react-admin";

export function ActivateChallengeTemplateButton({
  onClick,
}: {
  onClick: (record: any) => void;
}) {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={(e) => {
        e.stopPropagation();
        onClick(record);
      }}
    >
      Aktivieren
    </Button>
  );
}
